/**
 * Centralized API functions for Home Layouts functionality
 */
import { getData, postData, putData, deleteData } from '../apiClient';

// get all home layouts with pagination and search
export const getHomeLayouts = async (params = {}, signal = null) => {
    try {
        const { page = 1, limit = 10, search = '' } = params;
        const queryParams = { page, limit, search };
        const result = await getData('/section/', queryParams, { signal });
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get home layouts API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// get single home layout by id
export const getHomeLayoutById = async (id) => {
    try {
        const result = await getData(`/section/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get home layout by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// create home layout
export const createHomeLayout = async (formData) => {
    try {
        const result = await postData('/section/', formData);
        return {
            data: {
                message: result.message,
                success: true,
                status: result.status
            }
        };
    } catch (error) {
        console.error('Create home layout API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                status: error.response?.status || 500,
                errors: error.response?.data?.errors || []
            }
        };
    }
};

// update home layout
export const updateHomeLayout = async (id, formData) => {
    try {
        const result = await putData(`/section/${id}`, formData);
        return {
            data: {
                message: result.message,
                success: true,
                status: result.status
            }
        };
    } catch (error) {
        console.error('Update home layout API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                status: error.response?.status || 500,
                errors: error.response?.data?.errors || []
            }
        };
    }
};

// delete home layout by id
export const deleteHomeLayout = async (id) => {
    try {
        const result = await deleteData(`/section/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                status: result.status
            }
        };
    } catch (error) {
        console.error('Delete home layout API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                status: error.response?.status || 500
            }
        };
    }
};
